<template>
	<div id="wl">
		<div class="searchBox">
			<span>快递：</span>
			<el-input style='width: 300px;' v-model="input" placeholder="请输入内容"></el-input>
			<span>快递类型：</span>
			 <el-select v-model="value" placeholder="请选择" disabled>
				<el-option label="中通" value="ZT"></el-option>
			 </el-select>
			 <el-button type="primary" @click='getData'>查询</el-button>
		</div>
		<div class="box">
			<ul>
				<li v-for="item in stepData">
					<p>{{item.AcceptTime}}</p><p>{{item.AcceptStation}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
	    data(){
	        return {
	           input:'' ,
			   value:'ZTO',
			   stepData:[]
	        }
	    },
	    methods:{
	        getData(){
				axios.get('http://hk.dajiuxing.com.cn/gxali', {
					params: {
					  n: this.input,
					  t:this.value
					}
				  })
				  .then( (res)=> {
					  if(res.data.State == 2  || res.data.State == 3){
						  this.stepData=res.data.Traces
					  }else{
						  this.stepData=res.data.Traces;
						  this.$message.warning('未查询到该物流信息')
					  }
				  })
				  .catch( (err)=> {
					console.log(err);
				  });				
			}
	    },
	    mounted(){
	        this.input=this.$route.query.id;
			this.getData()
	    }
	}
</script>

<style scoped="scoped">
	.searchBox{margin: 20px 0;}
	.box li{line-height: 30px;font-size: 14px;color: #666;overflow: hidden;}
	.box li p{float: left;}
	.box li p:first-child{margin-right: 20px}
	.box li p:last-child{width: calc(100% - 170px);}
</style>



// WEBPACK FOOTER //
// src/views/card/wl.vue